import { DependencyAdd } from '../DependencyAdd/DependencyAdd';
import { DEPENDENCY_SEARCH_PLACEHOLDER } from './constants';
import * as React from 'react';
import { IDependenciesSearchSelectProps } from './types';
import { SearchSelect } from '../../../../../base/components/SearchSelect/SearchSelect';
import { AnalyzeRender } from '../../../../../helpers/memoizeHelper';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`DependenciesSearchSelect`) : null;

export function DependenciesSearchSelect ({
    availableCards,
    isOpened,
    isPopup,
    onAdd,
    onAddClosed,
}: IDependenciesSearchSelectProps) {
    if (analyzeRender) analyzeRender.call(`DependenciesSearchSelect`);
    return (
        <SearchSelect
            isCloseOnClick={false}
            isCloseOnEnter={false}
            isFitWindow={ isPopup }
            isDropdownUplifted={!isPopup}
            opened={ isOpened }
            options={ availableCards }
            option={ DependencyAdd }
            placeholder={ DEPENDENCY_SEARCH_PLACEHOLDER }
            onBlur={ onAddClosed }
            onClosed={ onAddClosed }
            onSelect={ (cardId) => onAdd(Number(cardId)) }
        />
    )
}
